export const ERRORS = {
	serverError: 'Sistēmas kļūda!',
	notAllowed: 'Dotā darbība nav atļauta!',
	permissionError: 'Jums nav atļaujas veikt doto darbību!',
	resourceNotFound: 'Pieprasītie dati netika atrasti!',
	validationFail: 'Pārbaudiet, vai ievadītie dati ir korekti!',

	// Take state messages
	takeHasEnded: 'Pārbaudes darba izpildes laiks ir beidzies! Iesniedziet darbu!',

	// File validation messages
	validationFileSize: 'Faila izmērs ir pārāk liels!',

	// User validation messages
	validationEmailExists: 'Lietotājs ar doto e-pastu jau eksistē!',
	validationRolePermissions: 'Jums nav atļaujas izveidot lietotāju ar doto grupu!',
	validationIncorrectPassword: 'Ievadītā parole nesakrīt ar esošo!',

	// Validation messages
	validationProgramExists: 'Programma ar doto nosaukumu jau eksistē!',
	validationGradeExists: 'Klase ar doto nosaukumu jau eksistē!',
	validationBlankExists: 'Sagatave ar doto nosaukumu jau eksistē izvēlētajā klasē!',
	validationSubjectExists: 'Kurss ar doto nosaukumu jau eksistē!',
	validationCourseExists: 'Modulis ar doto nosaukumu jau eksistē izvēlētajā kursā!',
	validationMaterialExists: 'Materiāls ar doto nosaukumu jau eksistē izvēlētajā modulī!',
	validationExamExists: 'Izvēlētajā modulī jau ir aktīvs pārbaudes darbs!',
};

export const ACTIONS = {
	// User messages
	createUserSuccess: 'Lietotājs veiksmīgi izveidots!',
	updateUserSuccess: 'Lietotāja dati veiksmīgi atjaunoti!',
	updateUserAddressSuccess: 'Adrese veiksmīgi atjaunota!',
	updateUserPasswordSuccess: 'Parole veiksmīgi nomainīta!',
	updateUserRecoverySuccess: 'Atjaunošanas e-pasts veiksmīgi nosūtīts!',
	deleteUserSuccess: 'Lietotājs veiksmīgi izdzēsts!',

	// Teacher messages
	updateTeacherCoursesSuccess: 'Pedagoga moduļi veiksmīgi atjaunoti!',

	// Student messages
	updateStudentGradesSuccess: 'Studenta mācību plāns veiksmīgi atjaunots!',
	updateStudentMarksSuccess: 'Studenta sekmes veiksmīgi atjaunotas!',
	updateStudentPaymentsSuccess: 'Studenta maksājumi veiksmīgi atjaunoti!',
	updateStudentParentsSuccess: 'Studenta vecāki veiksmīgi atjaunoti!',

	// Parent messages
	updateParentChildrenSuccess: 'Vecāka bērni veiksmīgi atjaunoti!',
	
	// Article messages
	createArticleSuccess: 'Aktualitāte veiksmīgi izveidota!',
	updateArticleSuccess: 'Aktualitātes dati veiksmīgi atjaunoti!',
	updateArticleGradesSuccess: 'Aktualitātes klases veiksmīgi atjaunotas!',
	updateArticleCoursesSuccess: 'Aktualitātes moduļi veiksmīgi atjaunoti!',
	deleteArticleSuccess: 'Aktualitāte veiksmīgi izdzēsta!',

	// Program messages
	createProgramSuccess: 'Programma veiksmīgi izveidota!',
	updateProgramSuccess: 'Programmas dati veiksmīgi atjaunoti!',
	deleteProgramSuccess: 'Programma veiksmīgi izdzēsta!',

	// Grade messages
	createGradeSuccess: 'Klase veiksmīgi izveidota!',
	updateGradeSuccess: 'Klases dati veiksmīgi atjaunoti!',
	deleteGradeSuccess: 'Klase veiksmīgi izdzēsta!',
	updateGradeStudentStateSuccess: 'Studenta klases statuss veiksmīgi atjaunots!',
	updateGradeStudentTransferSuccess: 'Studentu pārcelšana veiksmīga!',
	updateGradeStudentCourseSuccess: 'Moduļa pievienošana veiksmīga!',

	// Blank messages
	createBlankSuccess: 'Sagatave veiksmīgi izveidota!',
	updateBlankSuccess: 'Sagataves dati veiksmīgi atjaunoti!',
	updateBlankCoursesSuccess: 'Sagataves moduļi veiksmīgi atjaunoti!',
	deleteBlankSuccess: 'Sagatave veiksmīgi izdzēsta!',
	createBlankCopySuccess: 'Sagataves kopija veiksmīgi izveidota!',

	// Subject messages
	createSubjectSuccess: 'Kurss veiksmīgi izveidots!',
	updateSubjectSuccess: 'Kursa dati veiksmīgi atjaunoti!',
	deleteSubjectSuccess: 'Kurss veiksmīgi izdzēsts!',

	// Course messages
	createCourseSuccess: 'Modulis veiksmīgi izveidots!',
	updateCourseSuccess: 'Moduļa dati veiksmīgi atjaunoti!',
	updateCourseMaterialsSuccess: 'Moduļa materiāli veiksmīgi atjaunoti!',
	deleteCourseSuccess: 'Modulis veiksmīgi izdzēsts!',

	// Material messages
	createMaterialSuccess: 'Materiāls veiksmīgi izveidots!',
	updateMaterialSuccess: 'Materiāla dati veiksmīgi atjaunoti!',
	updateMaterialContentSuccess: 'Materiāla saturs veiksmīgi atjaunots!',
	deleteMaterialSuccess: 'Materiāls veiksmīgi izdzēsts!',
	createMaterialCopySuccess: 'Materiāla kopija veiksmīgi izveidota!',

	// Exam messages
	createExamSuccess: 'Pārbaudes darbs veiksmīgi izveidots!',
	updateExamSuccess: 'Pārbaudes darba dati veiksmīgi atjaunoti!',
	updateExamTasksSuccess: 'Pārbaudes darba uzdevumi veiksmīgi atjaunoti!',
	deleteExamSuccess: 'Pārbaudes darbs veiksmīgi izdzēsts!',

	// Student exam messages
	startTakeSuccess: 'Pārbaudes darbs ir sācies!',
	endTakeSuccess: 'Pārbaudes darbs ir iesniegts!',

	// Take messages
	updateTakeSuccess: 'Pārbaudes darba vērtējums veiksmīgi saglabāts!',

	// Student answer messages
	updateAnswersSuccess: 'Pārbaudes darba atbildes veiksmīgi saglabātas!',
	uploadAnswersSuccess: 'Pārbaudes darba atbildes veiksmīgi augšupielādētas!',
	removeAnswersSuccess: 'Pārbaudes darba atbildes veiksmīgi izdzēstas!',

	// Webinar messages
	createWebinarSuccess: 'Vebinārs veiksmīgi izveidots!',
	updateWebinarSuccess: 'Vebināra dati veiksmīgi atjaunoti!',
	deleteWebinarSuccess: 'Vebinārs veiksmīgi izdzēsts!',
	createWebinarCopySuccess: 'Vebināra kopija veiksmīgi izveidota!',

	// Mark messages
	createMarkSuccess: 'Vērtējums veiksmīgi pievienots!',
	updateMarkSuccess: 'Vērtējums veiksmīgi atjaunots!',
	deleteMarkSuccess: 'Vērtējums veiksmīgi izdzēsts!',

	// Report messages
	createReportSuccess: 'Liecības dati veiksmīgi atjaunoti!',
	updateReportSuccess: 'Liecības dati veiksmīgi atjaunoti!',

	// Certificate messages
	createCertificateSuccess: 'Atestāta dati veiksmīgi atjaunoti!',
	updateCertificateSuccess: 'Atestāta dati veiksmīgi atjaunoti!',

	// Final messages
	createStudentFinalSuccess: 'Eksāmens veiksmīgi pievienots!',
	updateStudentFinalSuccess: 'Eksāmena dati veiksmīgi atjaunoti!',
	deleteStudentFinalSuccess: 'Eksāmens veiksmīgi izdzēsts!',

	// Award messages
	createAwardSuccess: 'Apbalvojums veiksmīgi pievienots!',
	updateAwardSuccess: 'Apbalvojuma dati veiksmīgi atjaunoti!',
	deleteAwardSuccess: 'Apbalvojums veiksmīgi izdzēsts!',

	// Mail messages
	sendStudentReportSuccess: 'Liecība veiksmīgi nosūtīta studentam!'
};